/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

export type GetSocialBilibiliLiveroomRequest = {
  mid?: string | undefined;
  room_id?: string | undefined;
};

export const GetSocialBilibiliLiveroomRequest$zodSchema: z.ZodType<
  GetSocialBilibiliLiveroomRequest
> = z.object({
  mid: z.string().describe("主播的用户ID (`mid`)。与 `room_id` 任选其一。")
    .optional(),
  room_id: z.string().describe(
    "直播间ID，可以是长号（真实ID）或短号（靓号）。与 `mid` 任选其一。",
  ).optional(),
});

/**
 * 主播佩戴的头像框、大航海等级等信息，结构可能比较复杂。
 */
export type NewPendants = {};

export const NewPendants$zodSchema: z.ZodType<NewPendants> = z.object({})
  .describe("主播佩戴的头像框、大航海等级等信息，结构可能比较复杂。");

/**
 * 成功！返回直播间的详细信息。
 */
export type GetSocialBilibiliLiveroomResponse = {
  uid?: number | undefined;
  room_id?: number | undefined;
  short_id?: number | undefined;
  attention?: number | undefined;
  online?: number | undefined;
  live_status?: number | undefined;
  area_id?: number | undefined;
  parent_area_name?: string | undefined;
  area_name?: string | undefined;
  background?: string | undefined;
  title?: string | undefined;
  user_cover?: string | undefined;
  description?: string | undefined;
  live_time?: string | undefined;
  tags?: string | undefined;
  hot_words?: Array<string> | undefined;
  new_pendants?: NewPendants | undefined;
};

export const GetSocialBilibiliLiveroomResponse$zodSchema: z.ZodType<
  GetSocialBilibiliLiveroomResponse
> = z.object({
  area_id: z.number().optional(),
  area_name: z.string().optional(),
  attention: z.number().optional(),
  background: z.string().optional(),
  description: z.string().optional(),
  hot_words: z.array(z.string()).optional(),
  live_status: z.number().optional(),
  live_time: z.string().optional(),
  new_pendants: z.lazy(() => NewPendants$zodSchema).optional(),
  online: z.number().optional(),
  parent_area_name: z.string().optional(),
  room_id: z.number().optional(),
  short_id: z.number().optional(),
  tags: z.string().optional(),
  title: z.string().optional(),
  uid: z.number().optional(),
  user_cover: z.string().optional(),
}).describe("成功！返回直播间的详细信息。");
